import { render, staticRenderFns } from "./MealRestrictionSummary2.vue?vue&type=template&id=603e11b4&"
import script from "./MealRestrictionSummary2.vue?vue&type=script&lang=js&"
export * from "./MealRestrictionSummary2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports